enum ELocale {
  RU = 'ru',
  EN = 'en',
}

export default ELocale;
